export const NEWBUILDING_BUILDER_CALL_REASONS = 'newbuilding_builder_call_reasons';
export const NEWBUILDING_KPN_NEW_ENTERS = 'newbuilding_kpn_new_enters';
